module.exports = __webpack_public_path__ + "static/media/bg_unconnected.34f6e736.jpg";